import { render } from "./MaintenancePage.vue?vue&type=template&id=05d3e07a"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=05d3e07a&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__